export class TransactionFacade {
  constructor(transaction: Partial<TransactionFacade>) {
    if (transaction.id == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} id cannot be null`,
      );
    if (transaction.orderId == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} orderId cannot be null`,
      );
    if (transaction.customerId == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} customerId cannot be null`,
      );
    if (transaction.merchantId == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} merchantId cannot be null`,
      );
    if (transaction.date == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} date cannot be null`,
      );
    if (transaction.customerFirstName == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} customerFirst cannot be null`,
      );
    if (transaction.customerLastName == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} customerLast cannot be null`,
      );
    if (transaction.type == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} type cannot be null`,
      );
    if (transaction.totalAmount == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} totalAmount cannot be null`,
      );
    if (transaction.paymentMethodId == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} paymentMethodId cannot be null`,
      );
    //if (transaction.paymentMethodType == null)
    //    throw new Error(`Invalid transaction in constructor: ${JSON.stringify(transaction)} paymentMethodType cannot be null`);
    if (transaction.cardLast4 == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} cardLast4 cannot be null`,
      );
    if (transaction.cardFirst6 == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} cardFirst6 cannot be null`,
      );
    if (transaction.cardExpMonth == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} cardExpMonth cannot be null`,
      );
    if (transaction.cardExpYear == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} cardExpYear cannot be null`,
      );
    if (transaction.cardType == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} cardType cannot be null`,
      );
    if (transaction.mid == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} mid cannot be null`,
      );
    if (transaction.successful == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} successful cannot be null`,
      );
    if (transaction.allowRefund == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} allowRefund cannot be null`,
      );
    if (transaction.allowVoid == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} allowVoid cannot be null`,
      );
    if (transaction.allowCapture == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} allowCapture cannot be null`,
      );
    if (transaction.maxRefundAmount == null)
      throw new Error(
        `Invalid transaction in constructor: ${JSON.stringify(transaction)} maxRefundAmount cannot be null`,
      );

    this.id = transaction.id;
    this.mid = transaction.mid;
    this.orderId = transaction.orderId;
    this.customerId = transaction.customerId;
    this.merchantId = transaction.merchantId;
    this.processorTransactionNumber = transaction.processorTransactionNumber;
    this.date = transaction.date;
    this.customerFirstName = transaction.customerFirstName;
    this.customerLastName = transaction.customerLastName;
    this.type = transaction.type;
    this.totalAmount = transaction.totalAmount;
    this.paymentMethodId = transaction.paymentMethodId;
    //this.paymentMethodType = transaction.paymentMethodType;
    this.cardLast4 = transaction.cardLast4;
    this.cardFirst6 = transaction.cardFirst6;
    this.cardExpMonth = transaction.cardExpMonth;
    this.cardExpYear = transaction.cardExpYear;
    this.cardType = transaction.cardType;
    this.transactionDetails = transaction.transactionDetails;
    this.merchantLegalName = transaction.merchantLegalName;
    this.successful = transaction.successful;

    this.magnifiedAmount = transaction.magnifiedAmount;
    this.magnifier = transaction.magnifier;
    this.allowRefund = transaction.allowRefund;
    this.allowVoid = transaction.allowVoid;
    this.allowCapture = transaction.allowCapture;
    this.maxRefundAmount = transaction.maxRefundAmount;
  }

  id: string;
  orderId: string;
  customerId: string;
  merchantId: string;
  mid: string;
  processorTransactionNumber: string | undefined;
  date: string;
  merchantLegalName: string | undefined;
  customerFirstName: string;
  customerLastName: string;
  type: string;
  totalAmount: string;

  currencyCode: string | undefined;
  paymentMethodId: string;
  //paymentMethodType:string;
  cardLast4: string;
  cardFirst6: string;
  cardExpMonth: string;
  cardExpYear: string;
  cardType: string;
  transactionDetails: string | undefined;
  //invoiceId:string | undefined;
  batchNumber: string | undefined;
  batchDate: string | undefined;
  successful: boolean;

  // Only for submitting a new transaction
  magnifiedAmount: number | undefined;
  magnifier: number | undefined;

  allowRefund: boolean = false;
  allowVoid: boolean = false;
  allowCapture: boolean = false;
  maxRefundAmount: number = 0;

  static demagnifyAmount(magnifiedAmount: number, magnifier: number): number {
    if (!magnifier && !magnifiedAmount) {
      return 0
    } else if (magnifier) {
      return magnifiedAmount / magnifier;
    } else {
      throw 'missing magnified amount or magnifier in transaction';
    }
  }

  static getFormattedAmount(
    magnifiedAmount: number,
    magnifier: number,
    currencyCode: string,
  ): string {
    console.log('getFormattedAmount', magnifiedAmount, magnifier, currencyCode);
    const amt = TransactionFacade.demagnifyAmount(magnifiedAmount, magnifier); // will throw if divide by zero
    if (!currencyCode) {
      throw 'missing currency code in transaction';
    } else {
      switch (currencyCode) {
        case 'USD':
          return '$' + amt;
        default:
          throw 'unrecognized currency code in transaction: ' + currencyCode;
      }
    } 
  }
}
